import { forwardRef } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import './primitives.css';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: ReactNode;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { label, className, ...rest },
  ref,
) {
  const classes = ['lm-switch', className].filter(Boolean).join(' ');
  return (
    <label className={classes}>
      <input ref={ref} type="checkbox" {...rest} />
      <span className="lm-switch__track">
        <span className="lm-switch__thumb" />
      </span>
      {label && <span>{label}</span>}
    </label>
  );
});
